import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';

//Servicios

//Modelos

//Componentes
import Spinner from '../../components/spinner/Spinner';
import NewDJTV from './NewDJTV';

function NewDJTVContainer() {
    const { toast, token, grapesVariety } = useGlobalContext();
    const Navigate = useNavigate();
    const Params = useParams();

    const [loader, setLoader] = useState(false);
    const [DJTVData, setDJTVData] = useState();

    const FormMethods = useForm();

    useEffect(() => {
        // async function fetchDJTV() {
        //     try {
        //         setLoader(true);
        //         //Obtenemos la DJTV segun el id de los params
        //         const DJTV = await DJCPService.single({
        //             token,
        //             id: parseInt(Params.id),
        //         });
        //         if (DJTV) {
        //             //Establecemos los datos para la nueva DJTV
        //             const newDJTV = new NewDJCPModel({
        //                 cabecera: DJTV.data.cabecera,
        //                 items: DJTV.data.items,
        //             });
        //             setDJTVData(newDJTV);
        //             setTableData(buildTableData(newDJTV.items));
        //             //Establecemos los valores iniciales del form
        //             let formValues = {};
        //             DJTV.data.items.forEach((it, i) => {
        //                 formValues[`kilos` + i] = it.kilos;
        //             });
        //             FormMethods.reset(formValues);
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //         return err;
        //     }
        // }
        // fetchDJTV();
    }, []);

    const onSubmit = async (data) => {
        try {
            setLoader(true);
            //Formacion del objeto para enviar en la peticion
            let formItems = { ...DJTVData };
            formItems.items.forEach((it, i) => {
                it.kilos = parseInt(data[`kilos` + i]);
            });

            //Peticion para actualizar la DJTV
            // const UpdateDJCTV = await DJCPService.update({
            //     token,
            //     declaracion: formItems,
            // });

            // //Si la respuesta es correcta, navegamos denuevo a la tabla de DJCPs y desplegamos mensaje de éxito
            // if (UpdateDJCTV) {
            //     Navigate(RoutesApp.Declaraciones.transferenciaViniedo);
            //     toast('DJTV enviada con éxito', { type: 'success' });
            // }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            console.log(err);
            return err;
        }
    };

    /**Funcion que crea el objeto para pasarle a la tabla que lista las DJCPs */
    const buildTableData = (
        data = [
            { id: 0, variedad: 0, superficie: 0, kilos: 0, id_declaracion: 0 },
        ]
    ) => {
        return {
            headers: ['Variedad de Uva', 'Superficie', 'Kilos Probables'],
            pagination: 10,
            data: data?.map((dj, i) => {
                return {
                    variedad: grapesVariety?.find(
                        (gv) => gv.codigo === dj.variedad
                    )?.variedad,
                    superficie: `${dj.superficie} m²`,
                    kilos: (
                        <input
                            {...FormMethods.register('kilos' + i)}
                            type={'number'}
                        />
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? (
        <Spinner />
    ) : (
        <NewDJTV
            functions={{
                ...FormMethods,
                onSubmit,
            }}
            states={{ tableData, DJTVData }}
        />
    );
}

export default NewDJTVContainer;
